import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBooking, setCustomerPhoto, setRefund, setRefundHold, setStep } from "../../../Reducer/bookingSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import White from "../../../Assets/images/white-bg.avif"
import Compressor from 'compressorjs';
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";
import Select from 'react-select'
import Modal from "../../../Helpers/Components/Modal";

const Price = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state?.booking?.booking)
    const [chosen, setChosen] = useState()
    const [proof, setProof] = useState()
    const [photo, setPhoto] = useState("")
    const setSteps = () => {
        dispatch(setStep(4))
    }
    const setPreview = () => {
        if (booking?.excess?.amount > 0 && Number(booking?.excessBalance?.reduce((total, value) => total + Number(value?.amount || 0), 0)) !== Number(booking?.excess?.amount)) {
            toast.error("Balance amount collected is wrong")
        } else if (Number(booking?.refund?.amount) < 0) {
            toast.error("Invalid Refund amount");
        } else if (Number(booking?.refund?.amount) > 0 && (!booking?.refund?.mode)) {
            toast.error("Refund amount paid mode is required");
        } 
        else if (Number(booking?.refund?.offer) > 0 && (!booking?.refund?.offerRemarks)) {
            toast.error("Refund Offer Remarks is required");
        } else if (!booking?.customer?.remarks) {
            toast.error("Customer Remarks is required")
        } else if (!photo) {
            toast.error("Form Photo is required")
        } else if (!booking?.customer?.kyc?.length || (booking?.customer?.kyc?.length && (!booking?.customer?.kyc?.find((element) => element.type === "dl")?.id || !booking?.customer?.kyc?.find((element) => element.type === "dl")?.photo?.length))) {
            toast.error("Please complete DL data to complete the booking")
        } else {
            props?.setPreview(true)
        }
    }
    const handleNext = async () => {
        props?.setPreview(true)
    }
    const checkFileSize = async (file) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            setLoading(true)
            const response = await Handler({ method: 'patch', url: `/booking/details/form/photo/${props?.bookingId}`, data: { formPhoto: file }, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                dispatch(setBooking({ formPhoto: response?.data }))
                setPhoto(response?.data)
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    };
    const compressImage = (file) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0]);
        }
    };
    const handleRefundChange = (e) => {
        dispatch(setRefund({ [e.target.name]: e.target.value }))
    }
    const handleBalance = (value, name, index) => {
        const balance = Array.isArray(booking?.excessBalance)
            ? booking.excessBalance.map((element, i) =>
                i === index
                    ? { ...element, [name]: value }
                    : element
            )
            : [{ [name]: value }];

        dispatch(setBooking({ excessBalance: balance }));
    };
    return (
        <React.Fragment>
            <Modal header="Photo" onShow={proof} toggle={() => setProof(false)} overlayToggle={() => setProof(false)}>
                <div className="modalPhoto">
                    <img src={chosen || White} alt="Proof" />
                </div>
            </Modal>
            <div className="row">
                <div className="col-xl-8">
                    <div className="row">
                        <div className="col-md-6 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="totalCost" className="form-label"> Total Cost Collected </label>
                                <input name="totalCost" id="totalCost" autoComplete="off" readOnly disabled className="form-control input-theme text-uppercase"
                                    value={booking?.totalCostCollected || 0} />
                            </div>
                        </div>
                    </div>
                    {
                        booking?.excess?.amount
                            ?
                            <div>
                                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label"> Balance Amount Collected </label>
                                        <input name="amount" id="amount" autoComplete="off" readOnly className="form-control input-theme text-uppercase" value={booking?.excess?.amount || ""} />
                                    </div>
                                </div>





                                {
                                    booking?.excessBalance?.length ? booking?.excessBalance?.map((element, i) => {
                                        return (
                                            <div className="row" key={i}>
                                                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                                    <div className="mb-3">
                                                        <label htmlFor={`balanceAmount${i}`} className="form-label"> Balance Amount {i + 1} </label>
                                                        <input name={`balanceAmount${i}`} id={`balanceAmount${i}`} autoComplete="off" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleBalance(e?.target?.value, "amount", i) } }} disabled={loading} className="form-control input-theme text-uppercase" value={element?.amount || ""} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                                    <div className="mb-3">
                                                        <label htmlFor={`balanceAmount${i}`} className="form-label"> Balance {i + 1} Pay Mode </label>
                                                        <Select
                                                            styles={{
                                                                control: (base, state) => ({
                                                                    ...base,
                                                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                                                    "&:hover": {
                                                                        borderColor: "#f16436"
                                                                    }
                                                                }),
                                                                option: (style, state) => ({
                                                                    ...style,
                                                                    backgroundColor: state.isSelected
                                                                        ? "#f16436"
                                                                        : (state.isFocused || state.isActive)
                                                                            ? "#f164361a"
                                                                            : "white",
                                                                    color: state.isSelected ? "white" : "black"
                                                                })
                                                            }}
                                                            onChange={(selectedOption) => {
                                                                handleBalance(selectedOption.value, "mode", i)
                                                            }}
                                                            isDisabled={loading}
                                                            options={[
                                                                { value: "UPI", label: "UPI" },
                                                                { value: "Cash", label: "Cash" },
                                                                { value: "Net Banking", label: "Net Banking" }
                                                            ]}
                                                            value={booking?.excessBalance?.length >= i ? { label: booking?.excessBalance[i]?.mode, value: booking?.excessBalance[i]?.mode } : {}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                                    <div className="mb-3">
                                                        <label htmlFor={`balanceAmount${i}`} className="form-label"> Balance {i + 1} Remarks </label>
                                                        <input name={`balanceAmount${i}`} id={`balanceAmount${i}`} onChange={(e) => handleBalance(e.target.value, "remarks", i)} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={element?.remarks || ""} />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                        : ""
                                }
                                {
                                    booking?.excess?.amount > 0 && (booking?.excess?.amount > (booking?.excessBalance?.length ? booking?.excessBalance?.reduce((total, num) => total + Number(num?.amount), 0) : 0))
                                        ?
                                        <i className="fa-solid fa-plus cursor-pointer mb-3 fs-4" onClick={() => {
                                            let balance = booking?.excessBalance?.length ? booking?.excessBalance?.filter(element => !element?.amount || !element?.mode || !element?.remarks)?.length : false
                                            if (balance) {
                                                toast.error("Please fill above balance properly")
                                            } else {
                                                const value = Array.isArray(booking?.excessBalance) ? booking.excessBalance : [];
                                                const updatedValue = [...value, { mode: "", amount: "", remarks: "" }];
                                                dispatch(setBooking({ excessBalance: updatedValue }));
                                            }
                                        }}></i>
                                        : ""
                                }










                            </div>
                            : ""
                    }
                    <div className="row">
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="refundHold" className="form-label"> Refund Hold </label>
                                <input name="refundHold" id="refundHold" autoComplete="off" onChange={(e) => { if (e.target.value == Number(e.target.value)) { dispatch(setRefundHold({ hold1: e.target.value })) } }} disabled={loading} className="form-control input-theme text-uppercase" value={booking?.refundHold?.hold1 || ""} />
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="refundHoldRemarks" className="form-label"> Hold Remarks </label>
                                <input name="refundHoldRemarks" id="refundHoldRemarks" autoComplete="off" onChange={(e) => dispatch(setRefundHold({ remarks: e.target.value }))} disabled={loading} className="form-control input-theme text-uppercase" value={booking?.refundHold?.remarks || ""} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="offer" className="form-label"> Refund Offer </label>
                                <input name="offer" id="offer" autoComplete="off" onChange={(e) => { if (e.target.value == Number(e.target.value)) { handleRefundChange(e) } }} disabled={loading} className="form-control input-theme text-uppercase" value={booking?.refund?.offer || ""} />
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="offerRemarks" className="form-label"> Refund Offer Remarks </label>
                                <input name="offerRemarks" id="offerRemarks" autoComplete="off" onChange={handleRefundChange} disabled={loading} className="form-control input-theme text-uppercase" value={booking?.refund?.offerRemarks || ""} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="amount" className="form-label"> Refund Amount </label>
                                <input name="amount" id="amount" autoComplete="off" readOnly disabled className="form-control input-theme text-uppercase" value={booking?.refund?.amount || ""} />
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="mode" className="form-label"> Refund Amount Mode </label>
                                <Select
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                            "&:hover": {
                                                borderColor: "#f16436"
                                            }
                                        }),
                                        option: (style, state) => ({
                                            ...style,
                                            backgroundColor: state.isSelected
                                                ? "#f16436"
                                                : (state.isFocused || state.isActive)
                                                    ? "#f164361a"
                                                    : "white",
                                            color: state.isSelected ? "white" : "black"
                                        })
                                    }}
                                    isDisabled={loading}
                                    options={[
                                        { value: "UPI", label: "UPI" },
                                        { value: "Cash", label: "Cash" },
                                        { value: "Net Banking", label: "Net Banking" }
                                    ]}
                                    onChange={(e) => { dispatch(setRefund({ mode: e.value })) }}
                                    value={booking?.refund?.mode ? { label: booking?.refund?.mode, value: booking?.refund?.mode } : ""}
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="remarks" className="form-label"> Refund Amount Remarks </label>
                                <input name="remarks" id="remarks" autoComplete="off" onChange={handleRefundChange} disabled={loading} className="form-control input-theme text-uppercase" value={booking?.refund?.remarks || ""} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="custRemarks" className="form-label"> Customer Remarks </label>
                                <Select
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                            "&:hover": {
                                                borderColor: "#f16436"
                                            }
                                        }),
                                        option: (style, state) => ({
                                            ...style,
                                            backgroundColor: state.isSelected
                                                ? "#f16436"
                                                : (state.isFocused || state.isActive)
                                                    ? "#f164361a"
                                                    : "white",
                                            color: state.isSelected ? "white" : "black"
                                        })
                                    }}
                                    isDisabled={loading}
                                    options={[
                                        { value: "Good", label: "Good" },
                                        { value: "Bad", label: "Bad" }
                                    ]}
                                    onChange={(e) => { dispatch(setCustomerPhoto({ remarks: e.value })) }}
                                    value={booking?.customer?.remarks ? { label: booking?.customer?.remarks, value: booking?.customer?.remarks } : ""}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="totalCost" className="form-label"> Form Photo </label>
                                <div className="main-div">
                                    <div className="btn-div">{loading ? " " : <label htmlFor="advPhoto" className="me-2 upload-btn">Upload</label>}
                                        <button className="btn-warning btn btn-sm" onClick={() => { if (booking?.formPhoto) { setChosen(booking?.formPhoto); setProof(true) } }}>View</button></div>
                                    <input type="file" accept="image/*" className="d-none" name="advPhoto" disabled={loading} id="advPhoto" onChange={(e) => { handleImage(e) }} />
                                    <img src={photo || White} alt="Advance" className="kycPhotoImg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4">
                    <div className="card">
                        <div className="card-body">
                            <h6 className="fw-bold">Amount Preview</h6>
                            {/* <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Rental Fee </label>
                                <label className="col-6">{booking?.rentalFee || 0}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Offer Per Day </label>
                                <label className="col-6">{booking?.offerPerDay || 0}</label>
                            </div>
                            {
                                booking?.point === 0.5 ?
                                    <div className="row">
                                        <label htmlFor="leadMode" className="form-label col-6"> Half Day Offer </label>
                                        <label className="col-6">{booking?.halfDayOffer || 0}</label>
                                    </div>
                                    : ""
                            }
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Delivery Fee </label>
                                <label className="col-6">{booking?.deliveryDetails?.price || 0}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Pickup Fee </label>
                                <label className="col-6">{booking?.pickupDetails?.price || 0}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Security Deposit </label>
                                <label className="col-6">{booking?.securityDeposit || 0}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Advance Paid </label>
                                <label className="col-6">{booking?.advance?.amount || 0}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Final Amount </label>
                                <label className="col-6">{booking?.totalAmount || 0}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Excess Charges </label>
                                <label className="col-6">{Number(booking?.excessCharges?.length ? booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount), 0) : 0) + Number(booking?.excess?.fuelCharges || 0) + Number(booking?.excess?.kmCharges || 0) + Number(booking?.excess?.timeCharges || 0)}</label>
                            </div> */}
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Final Per Day </label>
                                <label className="col-6">{Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Total Days </label>
                                <label className="col-6">{Number(booking?.totalDays) + Number(booking?.point || 0)}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Total Amount </label>
                                <label className="col-6">{((Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)) * Number(booking?.totalDays || 1)) + Number(booking?.point ? (booking?.rentalFee ? (Number(booking?.rentalFee) / 2) - Number(booking?.halfDayOffer || 0) : 0) : 0)}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Delivery Fee </label>
                                <label className="col-6">{booking?.deliveryDetails?.price || 0}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Pickup Fee </label>
                                <label className="col-6">{booking?.pickupDetails?.price || 0}</label>
                            </div>
                            <div className="row">
                                <label htmlFor="leadMode" className="form-label col-6"> Other Charges </label>
                                <label className="col-6">{Number(booking?.excessCharges?.length ? booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount), 0) : 0) + Number(booking?.excess?.fuelCharges || 0) + Number(booking?.excess?.kmCharges || 0) + Number(booking?.excess?.timeCharges || 0)}</label>
                            </div>
                            {
                                booking?.refund?.amount ? <div className="row">
                                    <label htmlFor="leadMode" className="form-label col-6 fw-bold text-red"> Refund Amount </label>
                                    <label className="col-6 fw-bold text-red">{booking?.refund?.amount || 0}</label>
                                </div> : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
            <NextPrev step={5} setStep={setSteps} last={4} onClick={handleNext} loading={false} />
            <div className="text-center mt-4"><button className="btn btn-theme" onClick={() => { setPreview() }} disabled={loading}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Preview"}</button></div>
        </React.Fragment>
    )
}

export default Price;
